<template>
  <v-container grid-list-md>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          :color="dialog ? 'red' : 'primary'"
          dark
          v-bind="attrs"
          v-on="on"
        >
          <v-icon v-if="dialog">mdi-window-close</v-icon>
          <v-icon v-else>mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="primary darken-1 white--text"
          >Register New Client
          <v-spacer></v-spacer>
          <v-btn dark text icon @click="close">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-form ref="form" v-model="valid" class="mx-5">
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                v-model.trim="CustomerInfo.FullName"
                validate-on-blur
                :rules="[v => !!v || 'Full Name is required']"
                label="First Name"
                color="success"
                prepend-icon="mdi-account-edit"
                required
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6" sm="12">
              <v-text-field
                v-model="CustomerInfo.Cusphone"
                validate-on-blur
                :rules="[v => !!v || 'Phone is required', minlength]"
                label="Phone"
                color="success"
                prepend-icon="mdi-cellphone-basic"
                required
              >
              </v-text-field>
            </v-col>
            <!-- <v-col cols="12" md="6" sm="12">
              <v-text-field
                v-model.trim="CustomerInfo.IDNomber"
                validate-on-blur
                :rules="[v => !!v || 'Passport or other ID is required']"
                label="ID Number"
                color="success"
                prepend-icon="mdi-account-card-details-outline"
                required
              >
              </v-text-field>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <v-select
                v-model.trim="CustomerInfo.cashType"
                :items="GetCashTypes"
                :rules="[v => !!v || 'Cash Type is required']"
                label="Cash Type"
                required
                no-data-text="Refresh the page"
                prepend-icon="mdi-account-card-details-outline"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                v-model.number.trim="CustomerInfo.amount"
                :rules="[v => !!v || 'Amount is required']"
                name="OpenBalance"
                label="Opening Balance"
                type="number"
                prepend-icon="mdi-account-cash"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <p class="mt-md-4 font-weight-black" v-if="CustomerInfo.amount">
                {{ CustomerInfo.cashType | MoneySigns }}
                {{ CustomerInfo.amount.toLocaleString() }}
              </p>
            </v-col>
          </v-row>
          <!-- <p>{{ CustomerInfo }}</p> -->
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn
              color="success"
              class="mb-5"
              width="200px"
              :loading="clicked"
              @click="OnSaveCustomer"
            >
              Register
              <v-icon right>mdi-content-save-all</v-icon>
            </v-btn>
          </v-card-actions>
        </v-form>
        <p v-if="ErrorMsg" class="red--text d-flex mt-2 justify-center">
          {{ ErrorMsg }}
        </p>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    loadFunction: { type: Function, required: true },
  },
  data() {
    return {
      clicked: false,
      valid: true,
      date: null,
      dialog: false,
      menu: false,
      ErrorMsg: "",
      CustomerInfo: {
        FullName: null,
        Cusphone: null,
        IDNomber: null,
        cashType: null,
        amount: null,
      },
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  computed: {
    ...mapGetters(["GetCashTypes"]),
  },
  methods: {
    close() {
      this.dialog = false;
      this.$refs.form.reset();
      //   this.loadFunction();
    },
    isNumber(v) {
      if (v && isNaN(v)) return "Phone must be a number";
      else return false;
    },
    minlength(v) {
      if (!v) return "Required phone";
      return (
        v.toString().length > 8 || "Phone length must be at least 9 number"
      );
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    OnSaveCustomer() {
      this.ErrorMsg = "";

      if (this.$refs.form.validate()) {
        this.clicked = true;
        let [firstName, ...otherNames] = this.CustomerInfo.FullName.split(" ");
        // console.log(firstName);
        this.CustomerInfo.firstName = firstName;
        this.CustomerInfo.otherNames = otherNames.length
          ? otherNames.join(" ")
          : "";
        this.CustomerInfo.IDNomber = "none";
        this.CustomerInfo.date = this.Current().date;
        this.CustomerInfo.time = this.Current().time;
        // this.CustomerInfo.DOB = "1970-07-07";
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/customer",
            data: this.CustomerInfo,
          })
          .then(() => {
            this.$refs.form.reset();
            this.clicked = false;
            // this.CustomerInfo.firstName = null;
            // this.CustomerInfo.otherNames = null;
            // this.CustomerInfo.amount = null;

            // console.log(result);
            this.loadFunction();
            // this.close()
          })
          .catch(err => {
            this.clicked = false;
            // console.log(err.response);
            if (err.response.status === 400) this.ErrorMsg = err.response.data;
            if (err.response.status === 409)
              this.ErrorMsg = this.CustomerInfo.Cusphone + " is registred";
          });
      }
    },
  },
  // created() {
  //   console.log(this.Current());
  //   console.log("Date");
  // }
};
</script>
